import { get } from "./base";

export async function getOrderDetail(orderId) {
    let respObj = await get(`/bus/order/my-order-info/${orderId}`);
    return respObj;
}